import { render, staticRenderFns } from "./OmnichannelStrategyFilters.vue?vue&type=template&id=2aad76d7&scoped=true"
import script from "./OmnichannelStrategyFilters.vue?vue&type=script&lang=ts"
export * from "./OmnichannelStrategyFilters.vue?vue&type=script&lang=ts"
import style0 from "./OmnichannelStrategyFilters.vue?vue&type=style&index=0&id=2aad76d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad76d7",
  null
  
)

export default component.exports